import { createGlobalStyle } from 'styled-components';
import { media } from '../utils';

const GlobalStyle = createGlobalStyle`
    
    html, body {
      min-height: 100vh;
      width: 100%;
      font-family: ${(props) => props.theme.typography.fontFamily};
      font-size: 16px;
      height: 100%;
      line-height: 1.5;
      margin: 0;
      padding: 0;
      line-height: 1.5;
      position: relative;
      overflow:hidden;
    }

    body {
      background: ${(props) => props.theme.palette.neutral.shade1};
      color: ${(props) => props.theme.palette.neutral.shade8};
    }

    #root {
      width: 100%;
      min-height: 100vh;
      display: flex;
      height: 100%;
      width: 100%;

      ${() => media.mobile`
        flex-direction: column-reverse;
        height: calc(var(--vh, 1vh) * 100);
        min-height: calc(var(--vh, 1vh) * 100);
      `};

      ${() => media.tablet`
        flex-direction: column-reverse;
        height: calc(var(--vh, 1vh) * 100);
        min-height: calc(var(--vh, 1vh) * 100);
      `};
    }

    *, *::before, *::after {
      box-sizing: border-box;
    }
    
    *:focus {
      outline: none;
    }

    input[type=number] {
      -moz-appearance: textfield;
    }

    h1, h2, h3, h4, h5, h6, p {
      font-weight: 400;
      margin: 0;
    }
    
    h1 {
      font-size: 2rem;
    }

    a {
      text-decoration: none;
    }
    
    ::-webkit-scrollbar {
      width: 6px;
      height: 6px;
    }
    ::-webkit-scrollbar-track {
      background: ${(props) => props.theme.scrollbar.track};
    }
    ::-webkit-scrollbar-thumb {
      background: ${(props) => props.theme.scrollbar.thumb};
      border-radius: 4px;
    }
    ::-webkit-scrollbar-thumb:hover {
      background: ${(props) => props.theme.scrollbar.thumbHover};
    }
    ::-webkit-scrollbar-button {
      display: ${(props) => props.theme.scrollbar.buttonDisplay};
    }

    @font-face {
      font-family: 'Poppins';
      src: url('../../../assets/fonts/poppins/Poppins-Light.ttf') format('truetype');
      font-weight: 200;
      font-style: normal;
    }
    @font-face {
      font-family: 'Poppins';
      src: url('../../../assets/fonts/poppins/Poppins-Regular.ttf') format('truetype');
      font-weight: 400;
      font-style: normal;
    } 
    @font-face {
      font-family: 'Poppins';
      src: url('../../../assets/fonts/poppins/Poppins-Medium.ttf') format('truetype');
      font-weight: 500;
      font-style: normal;
    } 
    @font-face {
      font-family: 'Poppins';
      src: url('../../../assets/fonts/poppins/Poppins-SemiBold.ttf') format('truetype');
      font-weight: 600;
      font-style: normal;
    } 
    @font-face {
      font-family: 'Poppins';
      src: url('../../../assets/fonts/poppins/Poppins-Bold.ttf') format('truetype');
      font-weight: 700;
      font-style: normal;
    }
  `;

export default GlobalStyle;
